import { render, staticRenderFns } from "./helpSetBoxs.vue?vue&type=template&id=a288dac6&scoped=true"
import script from "./helpSetBoxs.vue?vue&type=script&lang=js"
export * from "./helpSetBoxs.vue?vue&type=script&lang=js"
import style0 from "./helpSetBoxs.vue?vue&type=style&index=0&id=a288dac6&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a288dac6",
  null
  
)

export default component.exports